<div *ngIf="payment" class="flex flex-column mt-4">
   <!-- HEADER -->
   <div class="bg-white flex justify-content-between align-items-center gap-3 w-full px-4">
      <div class="flex justify-content-start align-items-center gap-3">
         <div class="bg-blue-50 p-3 border-1 border-blue-100 border-round-lg">
            <i class="pi pi-credit-card text-blue-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            {{
               'DATA.MODULES.PAYMENTS.DETAILS.HEADER.PAYMENT_FOR' | translate: { customerName: payment?.customer?.name }
            }}
            <div class="text-sm font-normal text-600">
               {{ payment?.paymentDate | timezoneDate }}
            </div>
         </div>
      </div>
   </div>

   <p-divider></p-divider>

   <div class="flex w-full gap-4 p-4">
      <!-- LEFT COLUMN -->
      <div class="flex flex-column gap-3 w-5">
         <!-- PAYMENT AMOUNT -->
         <div class="call-info-item gradient1 bg-white border-round p-3 border-1 border-bluegray-100">
            <div class="icon-square bg-blue-50">
               <i class="pi pi-dollar text-blue-700 text-lg"></i>
            </div>
            <div class="text-column">
               <span class="text-bluegray-700">{{ 'DATA.MODULES.PAYMENTS.DETAILS.AMOUNT.LABEL' | translate }}</span>
               <p class="text-4xl font-bold text-blue-800">
                  {{ payment?.amount?.amount! | currencyWithCode: payment?.amount?.currency! }}
               </p>
            </div>
         </div>

         <!-- PAYMENT DETAILS -->
         <p-divider class="w-full" align="center">
            <span class="text-bluegray-400">{{ 'DATA.MODULES.PAYMENTS.DETAILS.PAYMENT_DETAILS' | translate }}</span>
         </p-divider>

         <div class="call-info-container bg-white border-round border-bluegray-100 border-1 p-4 gap-2">
            <div class="call-info-grid ml-2">
               <!-- PAYMENT ID -->
               <div class="call-info-item">
                  <div class="icon-square3">
                     <i class="pi pi-hashtag text-indigo-700 text-lg"></i>
                  </div>
                  <div class="text-column">
                     <span class="text-bluegray-600">{{ 'DATA.MODULES.PAYMENTS.DETAILS.PAYMENT_ID' | translate }}</span>
                     <span class="text-bluegray-800 font-semibold">
                        {{
                           payment?.method === PAYMENT_METHODS.PAYMEFY
                              ? payment?.externalId
                              : ('DATA.MODULES.PAYMENTS.DETAILS.EXTERNAL_PAYMENT_NOTE' | translate)
                        }}
                     </span>
                  </div>
               </div>

               <!-- CONCEPT -->
               <div class="call-info-item">
                  <div class="icon-square3">
                     <i class="pi pi-tag text-indigo-700 text-lg"></i>
                  </div>
                  <div class="text-column">
                     <span class="text-bluegray-600">{{ 'DATA.MODULES.PAYMENTS.DETAILS.CONCEPT' | translate }}</span>
                     <span class="text-bluegray-800 font-semibold">
                        {{ payment?.concept || '-' }}
                     </span>
                  </div>
               </div>

               <!-- METHOD -->
               <div class="call-info-item">
                  <div class="icon-square3">
                     <i class="pi pi-credit-card text-indigo-700 text-lg"></i>
                  </div>
                  <div class="text-column">
                     <span class="text-bluegray-600">{{ 'DATA.MODULES.PAYMENTS.DETAILS.METHOD' | translate }}</span>
                     <span class="text-bluegray-800 font-semibold">
                        {{ payment?.method }}
                     </span>
                  </div>
               </div>

               <!-- TYPE OF PAYMENT -->
               <!--<div class="call-info-item">
                  <div class="icon-square3">
                     <i class="pi pi-info-circle text-indigo-700 text-lg"></i>
                  </div>
                  <div class="text-column">
                     <span class="text-bluegray-600">{{
                        'DATA.MODULES.PAYMENTS.DETAILS.TYPE_OF_PAYMENT' | translate
                     }}</span>
                     <span class="text-bluegray-800 font-semibold">
                        {{ payment?.method || ('DATA.MODULES.PAYMENTS.DETAILS.UNKNOWN_PAYMENT' | translate) }}
                     </span>
                  </div>
               </div>-->

               <div class="call-info-item">
                  <div class="icon-square3">
                     <i class="pi pi-calendar text-indigo-700 text-lg"></i>
                  </div>
                  <div class="text-column">
                     <span class="text-bluegray-600">{{ 'DATA.MODULES.PAYMENTS.DETAILS.DATE' | translate }}</span>
                     <span class="text-bluegray-800 font-semibold">
                        {{ (payment?.paymentDate | timezoneDate) || '-' }}
                     </span>
                  </div>
               </div>

               <div class="call-info-item">
                  <div class="icon-square3">
                     <i class="pi pi-box text-indigo-700 text-lg"></i>
                  </div>
                  <div class="text-column">
                     <span class="text-bluegray-600">{{ 'DATA.MODULES.PAYMENTS.DETAILS.COLLECTOR' | translate }}</span>
                     <span class="text-bluegray-800 font-semibold">
                        {{ payment?.collector?.name || '-' }}
                     </span>
                  </div>
               </div>
            </div>
         </div>

         <!-- CUSTOMER -->
         <p-divider class="w-full" align="center">
            <span class="text-bluegray-400">{{ 'DATA.MODULES.PAYMENTS.DETAILS.CUSTOMER' | translate }}</span>
         </p-divider>

         <div class="flex flex-row gap-4 bg-white border-round border-bluegray-100 border-1 p-4 gap-2">
            <div class="icon-square3">
               <i class="pi pi-user text-indigo-700 text-lg"></i>
            </div>

            <div class="flex flex-column gap-2 flex-1">
               <div class="text-column">
                  <span class="text-bluegray-600">{{ 'DATA.MODULES.PAYMENTS.DETAILS.CUSTOMER_NAME' | translate }}</span>
                  <span class="text-bluegray-800 font-semibold">
                     {{ payment?.customer?.name }}
                  </span>
               </div>

               <div class="text-column">
                  <span class="text-bluegray-600">{{ 'DATA.MODULES.PAYMENTS.DETAILS.CUSTOMER_ID' | translate }}</span>
                  <span class="text-bluegray-800 font-semibold">
                     {{ payment?.customer?.externalId }}
                  </span>
               </div>

               <p-button
                  class="w-full mt-3"
                  styleClass="w-full"
                  label="{{ 'DATA.MODULES.PAYMENTS.DETAILS.VIEW_CUSTOMER' | translate }}"
                  icon="pi pi-external-link"
                  severity="secondary"
                  (onClick)="goToClient(payment.customer.id)"
               ></p-button>
            </div>
         </div>
      </div>

      <!-- DIVIDER -->
      <div class="flex align-items-stretch">
         <p-divider layout="vertical"></p-divider>
      </div>

      <!-- OPERATIONS -->
      <div class="flex flex-column gap-2 flex-1">
         <div class="flex justify-content-start align-items-center gap-3 pb-3">
            <div class="icon-square bg-indigo-50">
               <i class="pi pi-file text-indigo-700 text-lg"></i>
            </div>
            <div class="text-column">
               <span class="text-bluegray-700 text-xl font-semibold">{{
                  'DATA.MODULES.PAYMENTS.DETAILS.OPERATIONS' | translate
               }}</span>
               <div class="text-sm text-bluegray-500">
                  {{ 'DATA.MODULES.PAYMENTS.DETAILS.TOTAL_OPERATIONS' | translate }}:
                  <span class="font-semibold">{{ payment?.operations?.length }}</span>
               </div>
            </div>
         </div>

         <div
            *ngFor="let op of payment?.operations"
            class="w-full px-3 py-2 border-round border-bluegray-100 border-1 bg-white flex flex-column gap-3"
         >
            <div class="flex flex-column justify-content-between align-items-center gap-6 p-2 w-full">
               <div class="gap-2 w-full">
                  <p class="text-2xl font-bold text-indigo-800 mt-3 mb-0">{{ op.title }}</p>

                  <span class="text-bluegray-700 mt-0">{{
                     'DATA.MODULES.PAYMENTS.DETAILS.OPERATION' | translate: { id: op.externalId }
                  }}</span>

                  <div class="text-column mt-4">
                     <span class="text-bluegray-600">{{
                        'DATA.MODULES.PAYMENTS.DETAILS.PAID_AMOUNT' | translate
                     }}</span>
                     <span class="text-bluegray-800 font-semibold">
                        {{ op.amount.amount | currencyWithCode: op.amount.currency }}
                     </span>
                  </div>
               </div>

               <p-button
                  label="{{ 'DATA.MODULES.PAYMENTS.DETAILS.VIEW_OPERATION' | translate }}"
                  icon="pi pi-external-link"
                  styleClass="w-full"
                  class="w-full"
                  severity="secondary"
                  (onClick)="goToOperation(op.id)"
               ></p-button>
            </div>
         </div>
      </div>
   </div>

   <p-divider></p-divider>

   <!-- CLOSE BUTTON -->

   <div class="flex justify-content-end px-4 pb-4">
      <p-button
         label="{{ 'DATA.MODULES.PAYMENTS.DETAILS.CLOSE' | translate }}"
         severity="secondary"
         (onClick)="closeModal.emit()"
      ></p-button>
   </div>
</div>
